export default "__VITE_ASSET__WC3liUqv__"